import styled from "@emotion/styled";
import { FC, ReactNode } from "react";

import { DesignToken, SpacingToken } from "@livechat/design-system-react-components";

import LinkStyledButton from "components/button/LinkStyledButton";
import { withVar } from "themes/helpers";

// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6196): 'Props' is declared but never used.
// eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars
interface Props {
  title: string;
  iconUrl?: string;
  primaryButton: { label?: ReactNode; onClick?: VoidFunction; disabled?: boolean; testId?: string; custom?: ReactNode };
  secondaryButton?: { label: ReactNode; onClick: VoidFunction; disabled?: boolean };
  testId: string;
}

// @ts-expect-error TS(2552): Cannot find name 'IProps'. Did you mean 'Props'?
export const TicketDetailsCardTitle: FC<IProps> = ({ title, iconUrl, primaryButton, secondaryButton, testId }) => (
  <Wrapper data-testid={testId}>
    <StyledTitle iconUrl={iconUrl} className={[iconUrl ? "with-icon" : undefined].filter(Boolean).join(" ")}>
      {title}
    </StyledTitle>
    {secondaryButton && (
      <StyledLink disabled={secondaryButton.disabled} onClick={secondaryButton.onClick} type="button">
        {secondaryButton.label}
      </StyledLink>
    )}
    {primaryButton.custom || (
      <StyledLink
        disabled={primaryButton.disabled}
        onClick={primaryButton.onClick}
        type="button"
        data-testid={primaryButton.testId}
      >
        {primaryButton.label}
      </StyledLink>
    )}
  </Wrapper>
);

export const StyledLink = styled(LinkStyledButton)`
  margin-left: 10px;
  font-size: 14px;
  font-weight: normal;

  &:hover,
  &:active {
    text-decoration: none;
  }
`;

export const ActiveLink = styled(StyledLink)`
  cursor: pointer;
`;

export const DisabledLink = styled(StyledLink)`
  opacity: 0.5;
`;

const Wrapper = styled.div`
  display: flex;

  font-weight: 600;
  color: var(${DesignToken.ContentBasicPrimary});

  :not(:first-of-type) {
    padding-top: ${withVar(SpacingToken.Spacing4)};
  }
`;

const StyledTitle = styled.div<{
  iconUrl?: string;
}>`
  flex: 1;
  font-size: 14px;

  &.with-icon {
    &:before {
      background: url(${({ iconUrl }): string => (iconUrl ? iconUrl : "")}) 50% 50% / contain no-repeat;
      content: "";
      display: block;
      width: 20px;
      height: 20px;
      float: left;
      margin: 0 6px 0 0;
    }
  }
`;
